<style lang="less" scoped>
.news{position: relative;width: 1200px;display: flex;}
.YearBar {position: relative;width: 720px;margin-left: -20px;}
.header {height: 12px;}
.el-tabs {position: absolute;width:720px;}
/deep/.el-tabs__item {font-size: 16px !important;padding:0px 24px;}
.el-tab-pane {width: 720px;}
.text{margin: 0px 20px;cursor: pointer;}
.newsTitle {font-size: 14px;height: 90px;margin-top:410px;margin-left: -670px;line-height: 22px; overflow: hidden;-webkit-line-clamp: 4;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;}
.YearBar span {color:blue;display:block;position: absolute;right: 0;height: 5px;margin-top: -35px;}
.name{margin-bottom: 20px;}
.right{width: 400px;margin-top: -10px;}
.main1{position: relative;width: 400px;height: 600px;}
.first1{margin-top:20px;margin-left:50px;text-align: left;}
.first1 span{font-size: 18px;text-align: left;font-weight: bold;}
.first1 p{font-size: 18px;text-align: right;font-weight: bold;margin-top: -23px;}
.first1 p:hover{color: rgb(44, 105, 196); cursor: pointer;}
ul{list-style-type:none;}
.second1{margin-top:5px;margin-left:10px;width: 360px;border-bottom: 1px solid rgb(235, 226, 226);cursor: pointer;}
.second1:hover{span{color: rgb(44, 105, 196);}}
.second1 span{font-size: 14px;display: block;text-align: left;font-weight: bold;margin-top: 5px;margin-bottom: 5px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
.second1 p{font-size: 14px;display: block;text-align: left;margin-top: 5px;margin-bottom: 5px;overflow: hidden;-webkit-line-clamp: 2;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis; /* for IE */font-size: 14px;color: #4A4A4A;overflow: hidden;line-height: 25px;position: relative;height: 50px;}
.second1 h4{font-size: 14px;text-align: left;margin-top: 5px;margin-bottom: 5px;}
/deep/.el-tabs__nav.is-stretch{display: block;}
</style>

<!--李旭 6.5-->
<template>
  <div class="news">
    <div class="YearBar">
      <div class="main">
        <el-tabs class="content" v-model="activeName" :stretch="true">
          <el-tab-pane v-for="(item, index) in Cardlist" :key="index" :label="item.title" :name="item.num">
            <div class="text" style="height:100%;">
              <h2 class="name">{{ NewsLeft.title}}</h2>
              <div class="icon-Title" style="display: flex;" @click="goDetails(NewsLeft.id)">
                <img v-if="NewsLeft.thumb !== ''" :src="NewsLeft.thumb" class="icon" style="{width: 546px;height: 373px;">
                <img v-if="NewsLeft.thumb === ''" src="static/images/moren.jpg" class="icon" style="{width: 546px;height: 373px;">
                <div class="newsTitle">{{ NewsLeft.introduce }} </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="right">
      <div class="main1">
        <div class="first1" >
          <span>热门展会信息</span>
          <p @click="getMore">更多</p>
        </div>
        <ul>
          <li v-for="(item, index) in newsRight" :key="index" @click="goDetails(item.id)">
            <div class="second1">
              <span>{{item.title}}</span>
              <p class="introduce">{{item.introduce}}</p>
              <h4>{{item.addtime*1000 | formatDate()}}</h4>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter'
export default {
  props: ['Cardlist'],
  mixins: [filters],
  data()
  {
    return {
      activeName: '1',
      newsLeft: [],
      newsRight: []
    }
  },
  computed:
  {
    NewsLeft()
    {
      return this.newsLeft
    }
  },
  created()
  {
    this.getCSHData()
  },
  watch:
  {
    activeName:
    {
      handler(nval, oval)
      {
        this.getData(nval)
      },
      immediate: true
    }
  },
  methods: {
    //初始化默认为最新年份的数据
    getCSHData(catid)
    {
      let params = {cmd: 'query', _major: 11, _minor: 5, _exp: `catid=181 and examine = 0`, orderby: 'hits Desc', init: 0, pageno: 1, pagesize: 5}
      window.post.getPost(params).then((ret) =>
      {
        this.newsLeft = ret[0].data[0]
        this.newsRight = ret[0].data
      })
    },
    //根据年份获取对应的数据
    getData(cur)
    {
      this.Cardlist.forEach(item =>
      {
        if (item.num === cur)
        {
          let params = {cmd: 'query', _major: 11, _minor: 5, _exp: `catid= ${item.catid} and examine = 0`, orderby: 'hits Desc', init: 0, pageno: 1, pagesize: 5}
          window.post.getPost(params).then((res) =>
          {
            this.newsLeft = res[0].data[0]
            this.newsRight = res[0].data
          })
        }
      })
    },
    //点击“更多”按钮，跳转到新闻列表页
    getMore()
    {
      let curid = null
      this.Cardlist.forEach(item =>
      {
        if (item.num === this.activeName)
          curid = item.catid
      })
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
      {
        let url = this.$router.resolve({path: '/NewsListApp', query: {catid: curid}})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/NewsList', query: {catid: curid}})
        window.open(url.href, '_blank')
      }
    },
    //点击新闻，跳转到详情页面
    goDetails(id)
    {
      let url = this.$router.resolve({path: '/DhxwDetails', query: {id: id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Previousreview.vue